import BrandLogo from "../components/BrandLogo";

export default function PrivacyPage() {
  return (
    <div className="policy-page" style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ""}/cream-pattern-seamless-v2.svg)` }}>
      <header className="policy-header">
        <BrandLogo className="site-logo site-logo--small" label="Corte Gesya" />
      </header>

      <main className="policy-main">
        <article className="policy-card">
          <a className="back-link" href="/">← Torna alla home</a>

          <h1 className="policy-title">Informativa sul trattamento dei dati personali</h1>
          <p className="policy-updated">Ultimo aggiornamento: 30 ottobre 2026</p>

          <p>
            La presente informativa è resa ai sensi dell&apos;art. 13 del Regolamento (UE) 2016/679
            (&quot;GDPR&quot;) agli utenti che inviano una richiesta di informazioni tramite il sito
            cortegesya.com.
          </p>

          <h2>1. Titolare del trattamento</h2>
          <p>
            Il Titolare del trattamento è <strong>Immobiliare Ciurriero</strong>, con sede in
            Via Ariosto 1, 20030 Senago (MI), Italia.
          </p>
          <p>
            Contatti: <a href="mailto:info@immobiliareciurriero.it">info@immobiliareciurriero.it</a>
            {" "}— tel. <a href="tel:+390299485275">+39 02 99485275</a>.
          </p>

          <h2>2. Dati personali trattati</h2>
          <p>
            Attraverso il modulo di contatto possono essere raccolti: nome, cognome, indirizzo e-mail,
            numero di telefono, tipologia immobiliare di interesse, comune di residenza, data e ora
            della richiesta, presa visione dell&apos;informativa e, se espresso, consenso marketing.
          </p>
          <p>
            Possono inoltre essere trattati dati tecnici strettamente necessari al funzionamento,
            alla sicurezza e alla prevenzione di abusi del sito e dei relativi servizi.
          </p>

          <h2>3. Finalità e basi giuridiche</h2>

          <h3>Gestione della richiesta e attività commerciali collegate</h3>
          <p>
            I dati sono trattati per ricevere e gestire la richiesta dell&apos;utente, ricontattarlo,
            fornire informazioni su Corte Gesya, organizzare eventuali appuntamenti, approfondimenti
            commerciali o altre attività direttamente connesse alla richiesta inviata.
          </p>
          <p>
            La base giuridica è l&apos;esecuzione di misure precontrattuali adottate su richiesta
            dell&apos;interessato ai sensi dell&apos;art. 6, par. 1, lett. b) GDPR.
          </p>

          <h3>Adempimenti di legge, tutela dei diritti e sicurezza</h3>
          <p>
            I dati possono essere trattati quando necessario per adempiere obblighi di legge,
            rispondere a richieste delle autorità, tutelare i diritti del Titolare, prevenire abusi,
            frodi o utilizzi illeciti dei servizi.
          </p>
          <p>
            Le relative basi giuridiche sono l&apos;adempimento di obblighi legali e, ove applicabile,
            il legittimo interesse del Titolare ai sensi dell&apos;art. 6, par. 1, lett. c) e f) GDPR.
          </p>

          <h3>Marketing e comunicazioni promozionali</h3>
          <p>
            Solo con consenso facoltativo e specifico, Immobiliare Ciurriero e i suoi partner potranno
            utilizzare i dati di contatto per inviare comunicazioni commerciali e promozionali relative
            a Corte Gesya, ad altre iniziative immobiliari, opportunità, eventi o servizi, anche tramite
            e-mail, telefono, SMS e sistemi di messaggistica.
          </p>
          <p>
            La base giuridica è il consenso ai sensi dell&apos;art. 6, par. 1, lett. a) GDPR e della
            normativa italiana applicabile alle comunicazioni promozionali. Il consenso è facoltativo,
            non condiziona la gestione della richiesta immobiliare e può essere revocato in qualsiasi
            momento senza pregiudicare la liceità dei trattamenti già effettuati.
          </p>

          <h2>4. Natura del conferimento</h2>
          <p>
            I dati contrassegnati come obbligatori nel modulo sono necessari per gestire correttamente
            la richiesta. Il loro mancato conferimento può rendere impossibile fornire riscontro.
          </p>
          <p>
            Il consenso marketing è invece sempre facoltativo. Il mancato consenso non produce alcuna
            conseguenza sulla richiesta di informazioni o sulla possibilità di essere ricontattati
            in relazione a Corte Gesya.
          </p>

          <h2>5. Modalità del trattamento e sicurezza</h2>
          <p>
            Il trattamento avviene con strumenti informatici e telematici secondo principi di liceità,
            correttezza, trasparenza, minimizzazione e limitazione della conservazione. Sono adottate
            misure tecniche e organizzative adeguate al rischio per proteggere i dati da accessi non
            autorizzati, perdita, distruzione, modifica o divulgazione indebita.
          </p>

          <h2>6. Conservazione dei dati</h2>
          <p>
            I dati relativi a richieste che non danno luogo a un rapporto contrattuale sono conservati
            per un periodo massimo di <strong>24 mesi dall&apos;ultima interazione significativa</strong>,
            salvo necessità di ulteriore conservazione per la tutela di diritti o obblighi di legge.
          </p>
          <p>
            Se dalla richiesta nasce un rapporto contrattuale, i dati e la documentazione rilevante
            possono essere conservati per i più lunghi periodi previsti dalla normativa civilistica,
            fiscale, contabile o da altre disposizioni applicabili.
          </p>
          <p>
            I dati utilizzati per finalità di marketing sono conservati per un massimo di
            <strong>24 mesi dal consenso</strong>, salvo revoca o opposizione anticipata; allo scadere
            potranno essere cancellati, anonimizzati oppure il consenso potrà essere nuovamente richiesto.
          </p>

          <h2>7. Destinatari e fornitori tecnici</h2>
          <p>
            I dati possono essere trattati da personale autorizzato di Immobiliare Ciurriero e,
            quando necessario, da fornitori di servizi informatici, hosting, database, invio e-mail,
            sicurezza, manutenzione, consulenza professionale o altri soggetti che supportano il
            Titolare. Tali soggetti operano, ove previsto, quali responsabili del trattamento ai sensi
            dell&apos;art. 28 GDPR.
          </p>
          <p>
            Per l&apos;infrastruttura tecnica del sito possono essere utilizzati servizi Cloudflare,
            inclusi hosting, funzioni server, database e servizi di sicurezza o invio e-mail.
            L&apos;elenco aggiornato dei responsabili può essere richiesto al Titolare.
          </p>
          <p>
            Per finalità promozionali, i dati potranno essere comunicati ai partner commerciali di
            Immobiliare Ciurriero esclusivamente quando l&apos;interessato abbia espresso lo specifico
            consenso marketing. I dati non sono diffusi.
          </p>

          <h2>8. Trasferimenti fuori dallo Spazio Economico Europeo</h2>
          <p>
            Qualora alcuni fornitori tecnici trattino dati al di fuori dello Spazio Economico Europeo,
            il trasferimento avverrà nel rispetto del Capo V GDPR, mediante decisioni di adeguatezza,
            clausole contrattuali standard o altri strumenti di trasferimento previsti dalla normativa.
          </p>

          <h2>9. Diritti dell&apos;interessato</h2>
          <p>
            L&apos;interessato può esercitare, quando applicabili, i diritti previsti dagli artt. 15-22
            GDPR, tra cui accesso, rettifica, cancellazione, limitazione del trattamento, portabilità
            dei dati e opposizione.
          </p>
          <p>
            Il consenso può essere revocato in qualsiasi momento. Per il marketing è inoltre possibile
            opporsi in qualsiasi momento all&apos;utilizzo dei propri dati a fini promozionali.
          </p>
          <p>
            Le richieste possono essere inviate a{" "}
            <a href="mailto:info@immobiliareciurriero.it">info@immobiliareciurriero.it</a>.
          </p>
          <p>
            Resta fermo il diritto di proporre reclamo al Garante per la protezione dei dati personali
            oppure di rivolgersi all&apos;autorità giudiziaria competente.
          </p>

          <h2>10. Decisioni automatizzate</h2>
          <p>
            I dati raccolti tramite il modulo non sono utilizzati per assumere decisioni basate
            unicamente su trattamenti automatizzati che producano effetti giuridici o analogamente
            significativi sull&apos;interessato.
          </p>

          <h2>11. Modifiche all&apos;informativa</h2>
          <p>
            Il Titolare può aggiornare la presente informativa in caso di modifiche normative,
            organizzative o tecniche. La versione pubblicata su questa pagina indica la data
            dell&apos;ultimo aggiornamento.
          </p>
        </article>
      </main>
    </div>
  );
}
